import { render, staticRenderFns } from "./myCarrierGroup.vue?vue&type=template&id=74b054d9"
import script from "./myCarrierGroup.vue?vue&type=script&lang=js"
export * from "./myCarrierGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports